const LinkTargetBlank = ({ href, children }: any) => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-brand-secondary hover:text-brand-secondary/80"
      href={href}
    >
      {children}
    </a>
  );
};

export default LinkTargetBlank;
